var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_361_1181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5 30C82.0009 30 97 44.9991 97 63.5C97 82.0009 82.0009 97 63.5 97C44.9968 97 30 82.0009 30 63.5C30 44.9991 44.9968 30 63.5 30ZM63.5 34.4667C47.4647 34.4667 34.4667 47.4647 34.4667 63.5C34.4667 79.5353 47.4647 92.5333 63.5 92.5333C79.5353 92.5333 92.5333 79.5353 92.5333 63.5C92.5333 47.4647 79.5353 34.4667 63.5 34.4667ZM55.594 76.134L55.4243 75.9419L46.1381 66.6579C45.7315 66.2364 45.5068 65.6721 45.5123 65.0866C45.5178 64.501 45.7531 63.941 46.1675 63.5272C46.5818 63.1134 47.1422 62.8789 47.7277 62.8743C48.3133 62.8696 48.8773 63.0951 49.2982 63.5022L57.1819 71.3859L77.704 50.8683C78.1252 50.4614 78.6894 50.2363 79.2749 50.2414C79.8605 50.2465 80.4207 50.4814 80.8347 50.8955C81.2488 51.3095 81.4837 51.8697 81.4888 52.4553C81.4939 53.0408 81.2688 53.605 80.8619 54.0262L58.9306 75.9642C58.7357 76.2052 58.4925 76.4028 58.2168 76.5444C57.941 76.6859 57.6387 76.7682 57.3293 76.7861H57.0434C56.4968 76.7552 55.9807 76.5238 55.594 76.1362V76.134Z",
    fill: "url(#paint0_linear_361_1181)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_361_1181",
    x: 0,
    y: 0,
    width: 127,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.568627 0 0 0 0 0.980392 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_361_1181"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_361_1181",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_361_1181",
    x1: 31.4161,
    y1: 59.3454,
    x2: 94.3954,
    y2: 62.3541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47D7AC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.238facad008d598f9a427a886434ede1.svg";
export { ForwardRef as ReactComponent };